import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { getUnitCost, getVatByMstCategoryPrice } from "./HelperFunction";
import { getSupplierProductName } from "./HelperProduct";
export var handleOnSelectProductRowDefault = function(param) {
    var item = param.item, rowID = param.rowID, values = param.values, optionsWarehouse = param.optionsWarehouse, optionsMstVat = param.optionsMstVat, setProductRow = param.setProductRow;
    setProductRow(function(prev) {
        return prev.map(function(el) {
            if (el.rowID === rowID) {
                var _item_dimProduct, _item_dimProduct1;
                var warehouseID = null;
                var warehouseName = null;
                if (values.is_one_receiving_point) {
                    warehouseID = values.dim_warehouse_id;
                    var warehouse = optionsWarehouse.find(function(item) {
                        return values.dim_warehouse_id === item.value;
                    });
                    warehouseName = warehouse ? warehouse.label : "";
                }
                var dim_mst_vat_id = null;
                var vat = 0;
                optionsMstVat.map(function(v) {
                    if (item.dimProduct && item.dimProduct.vat === "ไม่มี VAT" && v.value === 1) {
                        dim_mst_vat_id = v.value;
                        vat = v.vat;
                    }
                    if (item.dimProduct && item.dimProduct.vat === "VAT 0%" && v.value === 2) {
                        dim_mst_vat_id = v.value;
                        vat = v.vat;
                    }
                    if (item.dimProduct && item.dimProduct.vat === "VAT 7%" && v.value === 3) {
                        dim_mst_vat_id = v.value;
                        vat = v.vat;
                    }
                });
                var vatByMstCatPrice = getVatByMstCategoryPrice(values.dim_mst_price_category_id, dim_mst_vat_id, vat);
                return _object_spread_props(_object_spread({}, el), {
                    productCode: item.dimProduct && item.dimProduct.sku ? item.dimProduct.sku : "-",
                    productID: item.id,
                    productName: item.dimProduct && item.dimProduct.name_th ? item.dimProduct.name_th : "-",
                    supplierCode: (_item_dimProduct = item.dimProduct) === null || _item_dimProduct === void 0 ? void 0 : _item_dimProduct.supplier_code,
                    supplierName: getSupplierProductName((_item_dimProduct1 = item.dimProduct) === null || _item_dimProduct1 === void 0 ? void 0 : _item_dimProduct1.supplier_names),
                    productRatioUnit: item.ratio_unit,
                    productContainer: item.container,
                    productBarcode: item.barcode,
                    sellPrice: item.price_1,
                    productPrice: getUnitCost(item),
                    productUnit: item.dimMasterUnit && item.dimMasterUnit.name ? item.dimMasterUnit.name : "-",
                    productUnitID: item.dimMasterUnit && item.dimMasterUnit.id ? item.dimMasterUnit.id : "-",
                    productOrdered: item.productOrdered,
                    ums: item.ums,
                    productStock: item.productStock,
                    warehouseID: warehouseID,
                    warehouseName: warehouseName,
                    discountType: 1,
                    discountPercent: 0,
                    discount: 0,
                    productQty: 1,
                    edit: false,
                    dim_mst_vat_id: vatByMstCatPrice.dim_mst_vat_id,
                    vat: vatByMstCatPrice.vat
                });
            }
            return el;
        });
    });
};
